import { FC, memo } from 'react';
import { useLocation } from 'react-router';
import { useDispatchRecordsQuery } from 'src/hooks/useDispatchRecords.query';

import DispatchRecordReportPresenter from './DispatchRecordReportPresenter';

/**
 * 配車表 のページ。
 * `/dispatch-record-report?start_on=YYYY-MM-DD&end_on=YYYY-MM-DD` で表示される。
 */
const DispatchRecordReport: FC = memo(() => {
  const query = new URLSearchParams(useLocation().search);
  const startOn = query.get('start_on') ?? '';
  const endOn = query.get('end_on') ?? '';

  const { data, isLoading, isError } = useDispatchRecordsQuery({ startOn, endOn });

  return (
    <DispatchRecordReportPresenter
      startOn={startOn}
      endOn={endOn}
      data={data}
      isLoading={isLoading}
      isError={isError}
    />
  );
});

export default DispatchRecordReport;
